export const handleSubmitForm = (values, onAddCLaim) => {
  const uploadData = {
    claimImage: values.claimImage ? values.claimImage[0] : null,
    receiptImage: values.receiptImage ? values.receiptImage[0] : null,
    warrantyId: values.warrantyId,
    customerCode: values.customerCode,
    detail1: values.detail1,
    detail2: values.detail2,
    breakdownId: values.breakdownId,
    addressLine1: values.addressLine1,
    addressLine2: values.addressLine2,
    subDistrictId: values.subDistrictId,
    zipCode: values.zipCode,
    other: values.other,
    isCreateNewAddress: values.isCreateNewAddress,
    channelClaimId: values.channelClaimId,
    storeId: values.storeId,
    bookingDate: values.bookingDate,
  };

  onAddCLaim(uploadData);
};
